import type { HumanoidAppearance } from '../GhostRenderer';
import { npc } from './npc';

/** The same woodland palette travels from the scout's lookout to the old grove. */
export const FOREST_JOURNEY_CAST: Record<string, HumanoidAppearance> = {
  forest_scout_iven: npc({
    shape: 'slim', color: '#c6a183', eyes: 'round', mouth: 'smile',
    humanoid: {
      fit: true,
      hair: { style: 'short', color: '#503d2f' },
      cloak: { color: '#526b47', claspColor: '#c5b082' },
      garment: { kind: 'tunic', color: '#8d805b', trimColor: '#d0be92', beltColor: '#55432e' },
      props: [{ kind: 'satchel', color: '#6b4e32', mapPeek: true }],
      art: { light: 'overcast', role: 'warden' },
    },
  }),
  forest_sawkeeper_hetta: npc({
    shape: 'wide', color: '#ab8063', eyes: 'round', mouth: 'neutral',
    humanoid: {
      fit: true,
      hair: { style: 'bun', color: '#493b32', streakColor: '#ac9b80' },
      garment: { kind: 'apron', color: '#816344', underColor: '#455a47',
        trimColor: '#c5a16b', beltColor: '#4b392c' },
      props: [{ kind: 'hammer', color: '#6a5940', headColor: '#8a9883' }],
      art: { light: 'lamp', role: 'merchant' },
    },
  }),
  forest_grovekeeper_senn: npc({
    shape: 'round', color: '#b6a38a', eyes: 'round', mouth: 'neutral',
    humanoid: {
      fit: true,
      hair: { style: 'thin', color: '#d0ccaf' },
      beard: { style: 'full', color: '#d0ccaf' },
      headgear: { kind: 'leaf_crown', color: '#688558', accentColor: '#b7a16c' },
      cloak: { color: '#3e5945', claspColor: '#b7a16c' },
      garment: { kind: 'tunic', color: '#7a8163', trimColor: '#c9c29d', beltColor: '#554c38' },
      props: [{ kind: 'cane', color: '#947551' }],
      art: { light: 'overcast', role: 'keeper' },
    },
  }),
};
